import { render, staticRenderFns } from "./MasterBrand.vue?vue&type=template&id=0f6f876a&scoped=true&"
import script from "./MasterBrand.vue?vue&type=script&lang=js&"
export * from "./MasterBrand.vue?vue&type=script&lang=js&"
import style0 from "../SalesForce.scss?vue&type=style&index=0&id=0f6f876a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6f876a",
  null
  
)

export default component.exports